import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./intro.module.css";
import { customerReviewsIntroData } from "../../data/customer-reviews-data";
export var Intro = function() {
    var title = customerReviewsIntroData.title;
    var body = customerReviewsIntroData.body;
    var customerReviewsIntroText = renderWithResolver(body);
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: styles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                children: customerReviewsIntroText
            })
        ]
    });
};
